module.exports = __webpack_public_path__ + "media/images/icons/filled/up-circle-6f05c2aab4ccc5eb997002f8f8e8d5a1.svg";